// extracted by mini-css-extract-plugin
export default {"wraper":"Policy_wraper__8ioR3","topic":"Policy_topic__rYXJV","more":"Policy_more__v88nO"};